import { atom } from 'jotai';

import { defaultLayoutState } from './Layout.constants';
import { LayoutState } from './Layout.types';

export const layoutState = atom<LayoutState>(defaultLayoutState);
